/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";

const StyledList = styled(({ theme, ...props }) => <List {...props} />)`
  dt {
    color: ${(props) => props.theme.palette.text.secondary};
  }

  dd {
    margin-left: 0;
  }
`;

const StyledGridCarrierDataItem = styled(Grid)`
  flex: 0 0 33.333333333%;
  padding-left: 8px;
`;

function CarrierDetails({ carrier }) {
  const theme = useTheme();
  let carrierEmails = carrier.carrierEmail
    ? carrier.carrierEmail.split(";")
    : null;

  const getCarrierEmails = () => {
    const carrierEmails = carrier.carrierEmail
      ? carrier.carrierEmail.split(";")
      : [];

    if (carrier.email2) {
      carrierEmails.push(carrier.email2);
    }

    if (carrier.email3) {
      carrierEmails.push(carrier.email3);
    }

    return carrierEmails;
  };

  return (
    <>
      <StyledGridCarrierDataItem item>
        <StyledList component="dl" theme={theme}>
          <dt>Carrier</dt>
          <dd>{carrier.carrierName}</dd>
        </StyledList>
      </StyledGridCarrierDataItem>
      <StyledGridCarrierDataItem item>
        <StyledList component="dl" theme={theme}>
          <dt>Contact</dt>
          <dd>{carrier.contactFullName ?? "--"}</dd>
        </StyledList>
      </StyledGridCarrierDataItem>
      <StyledGridCarrierDataItem item style={{ overflow: "hidden" }}>
        <StyledList component="dl" theme={theme}>
          <dt>Email</dt>
          {carrierEmails ? (
            <dd>
              {getCarrierEmails().map((carrierEmail, index) => (
                <span
                  style={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  key={index}
                >
                  <Tooltip title={carrierEmail} interactive>
                    <a href={`mailto:${carrierEmail}`}>{carrierEmail}</a>
                  </Tooltip>
                </span>
              ))}
            </dd>
          ) : (
            "--"
          )}
        </StyledList>
      </StyledGridCarrierDataItem>
      {carrier.carrierPhone1 && (
        <StyledGridCarrierDataItem item>
          <StyledList component="dl" theme={theme}>
            <dt>Phone #</dt>
            <dd>{carrier.carrierPhone1}</dd>
          </StyledList>
        </StyledGridCarrierDataItem>
      )}
      {carrier.carrierPhone2 && (
        <StyledGridCarrierDataItem item>
          <StyledList component="dl" theme={theme}>
            <dt>Phone #</dt>
            <dd>{carrier.carrierPhone2}</dd>
          </StyledList>
        </StyledGridCarrierDataItem>
      )}
      {carrier.carrierPhone3 && (
        <StyledGridCarrierDataItem item>
          <StyledList component="dl" theme={theme}>
            <dt>Phone #</dt>
            <dd>{carrier.carrierPhone3}</dd>
          </StyledList>
        </StyledGridCarrierDataItem>
      )}
    </>
  );
}

CarrierDetails.propTypes = {
  carrier: PropTypes.object,
};

export default CarrierDetails;
